/*
 * @Description: 开票记录
 * @Date: 2020年12月14日17:35:52
 * @LastEditors: Please set LastEditors
 */
import Vue from 'vue';
import { invoice, invoiceNew } from '@/api/ajax';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import createExtend from '@C/createExtend';
import fields, { OFFLINE_STATUS_INVOICE } from './fields';
import { moneyFixed } from '@/tools/money';

import addInvoice from '../../offline-invoice/add';
import invoiceDetail from '../../offline-invoice/detail';
import invoiceInfoList from '../../offline-invoice/invoiceInfoList';
import invoiceEdit from '../../offline-invoice/edit';

let example = new TableRenderClass({
  fields: {
    ...fields,
    invoicePrice: {
      width: 120,
      label: '开票金额',
      formatter(row) {
        return moneyFixed(row.invoiceAmount);
      }
    },
    openCompany: {
      label: '开票企业',
      prop: 'enterpriseName'
    },
    invoiceApplyType: {
      width: 140,
      label: '发票申请方式',
      formatter: row => {
        return ['', '客户申请', '主动开票'][row.invoiceApplicationType];
      }
    },
    toApplyForTime: {
      label: '申请时间',
      prop: 'createDt',
      formatter(row, ctx, v) {
        return Vue.filter('transAllTime')(v);
      }
    },
    theTimeMonthInvoice: {
      label: '结算月度',
      prop: 'taskDt'
    },
    theTimeOfMakeOutAnInvoice: {
      label: '上传时间',
      prop: 'openDt',
      formatter(row, ctx, v) {
        return Vue.filter('transAllTime')(v);
      }
    },
    offlineInvoiceStatus: {
      width: 120,
      label: '开票状态',
      prop: 'invoiceStatus',
      render(h, ctx, row) {
        const vm = ctx.parent;
        const { invoiceStatus, noPassReason } = row;
        // 如果是 驳回
        const isDeney = +invoiceStatus === 3;
        if (isDeney && noPassReason) {
          return h(
            'el-button',
            {
              props: {
                disabled: !isDeney,
                type: 'text'
              },
              on: {
                click: () => {
                  vm.$msgbox({
                    title: '驳回原因',
                    message: noPassReason
                  });
                }
              }
            },
            OFFLINE_STATUS_INVOICE.get(invoiceStatus)
          );
        }
        return h('span', OFFLINE_STATUS_INVOICE.get(invoiceStatus));
      }
    },

    offlineInvoiceOperate: {
      width: 120,
      label: '操作',
      prop: 'offlineInvoiceOperate',
      render(h, ctx, row) {
        const { invoiceStatus } = row;
        const vm = ctx.parent;
        const openDetail = () => {
          vm.$xrkDialog({
            title: '发票详情',
            width: '90vw',
            showCancel: false,
            showConfirm: false,
            $slots: {
              default: vm.$createElement(invoiceDetail, {
                props: {
                  id: row.id,
                  isLook: invoiceStatus == 4
                },
                on: {
                  confirm: () => {
                    vm.saveSuccess();
                    vm.$xrkDialog.remove();
                  }
                }
              })
            }
          });
        };
        const openEdit = () => {
          vm.$xrkDialog({
            title: '发票详情',
            width: '90vw',
            showCancel: false,
            showConfirm: false,
            $slots: {
              default: vm.$createElement(invoiceEdit, {
                props: {
                  id: row.id,
                  isLook: false
                },
                on: {
                  confirm: () => {
                    vm.saveSuccess();
                    vm.$xrkDialog.remove();
                  }
                }
              })
            }
          });
        };
        return (
          <div>
            {[0, 1].includes(+invoiceStatus) && (
              <el-button type="text" onClick={openDetail}>
                上传发票
              </el-button>
            )}
            {[2, 4].includes(+invoiceStatus) && (
              <el-button type="text" onClick={openEdit}>
                编辑
              </el-button>
            )}
            {[2, 4].includes(+invoiceStatus) && (
              <el-button type="text" onClick={openDetail}>
                发票详情
              </el-button>
            )}
            {[3].includes(+invoiceStatus) && (
              <el-button type="text" onClick={openDetail}>
                重新上传
              </el-button>
            )}
          </div>
        );
      }
    }
  },
  search
});

let tobeOpendPart = example.createPart({
  name: '开票记录',
  // search: ['invoicingSupplier', 'invoiceCategory', 'daterange','authDaterange'],
  search: ['jiesuangongyingshang', 'offlineInvoiceStatus'],
  list: invoiceNew.listInvoice,
  requestNow: true,
  fields: [
    'index',
    'openCompany', // 开票企业
    'invoicePrice', //开票金额
    'invoiceCategory', //发票类目
    'invoiceApplyType', //发票申请方式
    'theTimeMonthInvoice', //结算月度
    'theTimeOfMakeOutAnInvoice', //上传时间
    'offlineInvoiceStatus', //开票状态
    'offlineInvoiceOperate'
  ],
  moreBtnArr: [
    {
      name: '新增发票',
      type: 'primary',
      async fn(app, table) {
        table.$xrkDialog({
          title: '新增发票',
          width: '90vw',
          showCancel: false,
          showConfirm: false,
          $slots: {
            default: table.$createElement(invoiceDetail, {
              props: {
                isAdd: true
              },
              on: {
                confirm: e => {
                  table.saveSuccess();
                  table.$xrkDialog.remove();
                },
                cancel: () => {}
              }
            })
          }
        });
      }
    },
    {
      name: '开票信息维护',
      async fn(app, table) {
        table.$xrkDialog({
          title: '开票信息维护',
          width: '90vw',
          showCancel: false,
          showConfirm: false,
          $slots: {
            default: table.$createElement(invoiceInfoList, {
              props: {
                from: '发票上传'
              }
            })
          }
        });
      }
    }
  ]
});

export default tobeOpendPart;
